module.exports = __webpack_public_path__ + "fee0bb9c5b62966896e6b8866a6726ae.svg";